import { Controller } from "@hotwired/stimulus"

// UserSearchController - Admin user search combobox
// Used in: admin_panel/admin_messages/new.html.erb
export default class extends Controller {
  static targets = ["input", "results", "userId", "selectedUser", "selectedAvatar", "selectedName"]
  static values = { errorMessage: String }

  connect() {
    this.debounceTimer = null
    document.addEventListener("click", this.hideOnClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.hideOnClickOutside.bind(this))
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  search() {
    const query = this.inputTarget.value.trim()

    if (this.debounceTimer) clearTimeout(this.debounceTimer)

    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.debounceTimer = setTimeout(async () => {
      await this.fetchUsers(query)
    }, 300)
  }

  async fetchUsers(query) {
    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(`/admin/admin_messages/search_users?q=${encodeURIComponent(query)}`, {
        method: "GET",
        headers: {
          "Accept": "text/html",
          ...(token && { "X-CSRF-Token": token })
        },
        credentials: "same-origin"
      })

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const html = await response.text()
      this.resultsTarget.innerHTML = html
      this.showResults()
    } catch (error) {
      console.error("User search error:", error)
      const errorMsg = this.errorMessageValue || "Error"
      this.resultsTarget.innerHTML = `<div class="px-4 py-3 text-sm text-red-500">${errorMsg}</div>`
      this.showResults()
    }
  }

  selectUser(event) {
    const button = event.currentTarget
    const userId = button.dataset.userId
    const userName = button.dataset.userName
    const userAvatar = button.dataset.userAvatar

    // Set hidden field value
    this.userIdTarget.value = userId

    // Update selected user display
    if (userAvatar) {
      this.selectedAvatarTarget.innerHTML = `<img src="${userAvatar}" alt="" class="w-8 h-8 rounded-full">`
    } else {
      this.selectedAvatarTarget.innerHTML = `<div class="w-8 h-8 rounded-full bg-charcoal-200 dark:bg-charcoal-700 flex items-center justify-center text-charcoal-600 dark:text-charcoal-400 text-sm font-medium">${userName.charAt(0).toUpperCase()}</div>`
    }
    this.selectedNameTarget.textContent = userName

    // Show selected, hide input and results
    this.selectedUserTarget.classList.remove("hidden")
    this.inputTarget.value = ""
    this.inputTarget.classList.add("hidden")
    this.hideResults()
  }

  clearSelection() {
    this.userIdTarget.value = ""
    this.selectedUserTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
  }

  showResults() {
    this.resultsTarget.classList.remove("hidden")
  }

  hideResults() {
    this.resultsTarget.classList.add("hidden")
  }

  hideOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
}
